import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 21l6.324 -11.69c.54 -.974 1.756 -4.104 -1.499 -5.762c-3.255 -1.657 -5.175 .863 -5.825 2.032","key":"svg-0"}]]

/**
 * IconCane
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2FuZSIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNOSAyMWw2LjMyNCAtMTEuNjljLjU0IC0uOTc0IDEuNzU2IC00LjEwNCAtMS40OTkgLTUuNzYyYy0zLjI1NSAtMS42NTcgLTUuMTc1IC44NjMgLTUuODI1IDIuMDMyIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/cane
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCane = createReactComponent('outline', 'cane', 'Cane', __iconNode);

export default IconCane;